import Vue from 'vue'
import Vuex from 'vuex'
import campaign from './campaign-store'
import product from './product-store'
import notification from './notification-store'
import automation from './automation-store'
import accounts from './account-store';
import asinScapper from './asin-scraper-store'
import sales from './sales-diagnostic';
import release from './release-store';
import template from './template-store';
import map from './map-store.js';
import { serverUrl } from '../properties';
// import {page}  from 'vue-analytics';
const axios = require('axios');

Vue.use(Vuex)

const initialState = () => {
	return {
	  renderDelayVar:false,
	  destroyDelayVar:true,
	  openDrawer:true,
	  showHoverNavigation:false,
	  selectedVendorPartnerUuid:'',
	  clientList:[],
	  brandPerClient:[],
	  clientData:null,
	  selectedTag:'',
	  listOfTags:[],
	  calledFromCancel:false,
      showLoader: false,
	  currentPageNumber:1,
	  keywordCurrentPageNumber:1,
	  showPerPage:25,
	  keywordShowPerPage:25,
	  recommendedKeywordShowPerPage:25,
	  recommendedKeywordCurrentPageNumber:1,
      vendorList:[],
	  sellerList:[],
	  profileBrandList:[],
      brandProfileList:[],
      selectedVendorFilter:'',
      selectedBrandProfle:'',
      selectedCampaignGroupFilter:'',
      selectedSortOrder:{
				field:'name',
				order:'asc'
			},
      selectedPage:'Campaign',
      searchFilterString:'',
      selectedVendor:'',
	  selectedLastXDays:'',
	  selectedEntityTypeFilter:'',
	  latestCampaignGroup:'',
	  headers : {},
	  selectedVendorProduct : '',
	  selectedBrandProduct : '',
	  totalCampaignAndProductCount:0,
	  totalDspCount:0,
	  totalKeywordCount:0,
	  recommendedTotalKeywordCount:0,
	  keywordCurrentTab:"non_sync",
	  selectedVendorNotification:"",
	  selectedAccountContactFilter:"",
	  clientList:[],
	  selectedClientFilter:'',
	  grouping:'Group',
	searchKeywordFilterString:'',
	automationFilter:[],
	accountsFilter:[],
	campaignsFilter:[],
	keywordsFilter:[],
	refreshCampaign:false,
	tempCampGrpShowPerPage:25,
	tempCampGrpPageNo:1,
	productAdvanceFilter:[],
	tableauTicket:'',
	totalKeywordDescCount:0,
	keywordDescShowPerPage:25,
	keywordDescCurrentPageNumber:1,
	keywordDescList:[],
	recommendedKeywordList:[],
	isSeller:false,
	isFilter:false,
	isUserPrestige:false,
	isUserAdmin : false,
	dspTagList:[],
	showDspRows:false,
	dspRowCount: 0,
	dspAdvertiser:{
		name: 'All Advertisers',
		value: 0
	},
	dspTagType:{
		name: 'All Types',
		value: ''
	},
	dspAdvertisers: [],
	currentDspAdvertiser:'',
	serverReturnMessage:''
    }
}


export default new Vuex.Store({
  modules: {
    campaign,
    product,
    notification,
	automation,
	accounts,
	asinScapper,
	sales,
	release,
	template,
	map
  },
  state: initialState,
  getters: {
	getSelectedTag:(state,getters) =>{
		return state.selectedTag
	},
    getSelectedCampaignGroupFilter: (state, getters) => {
      return state.selectedCampaignGroupFilter
    },
    getSelectedBrandProfle: (state, getters) => {
		// if (sessionStorage.getItem("campaign:selectedBrandProfle")) {
		// 	return sessionStorage.getItem("campaign:selectedBrandProfle");
		// }else{
			return state.selectedBrandProfle
	//	}
    },
    getSearchFilterString: (state, getters) => {
      return state.searchFilterString
    },
    getSelectedSortOrder: (state, getters) => {
		 ;
      return state.selectedSortOrder
    },
    getSelectedVendor: (state, getters) => {
      return state.selectedVendor
    },
    getGrouping: (state, getters) => {
      return state.grouping
    },
    getSelectedLastXDays: (state, getters) => {
      return state.selectedLastXDays
    },
    getSelectedEntityTypeFilter: (state, getters) => {
      return state.selectedEntityTypeFilter
    },
    getCurrentPageNumber: (state, getters) => {
      return state.currentPageNumber
		},
		getKeywordCurrentPageNumber: (state, getters) => {
      return state.keywordCurrentPageNumber
		},
		getRecommendedKeywordCurrentPageNumber:(state, getters) => {
			return state.recommendedKeywordCurrentPageNumber
		},
		getKeywordShowPerPage: (state, getters) => {
      return state.keywordShowPerPage
    },
	getSelectedVendorFilter: (state, data) => {
		// if (sessionStorage.getItem("campaign:selectedVendorFilter")) {
		// 	return sessionStorage.getItem("campaign:selectedVendorFilter");
		// }else{
		// }
		return state.selectedVendorFilter
		},
    getShowPerPage: (state, getters) => {
      return state.showPerPage
    },
    getShowLoader: (state,getters) =>{
      return state.showLoader
  },
  fetchHeader : (state, getters) =>{

	  let idToken = '';
	  let name = '';
	  if(window.localStorage && window.localStorage.session){
		  let session = JSON.parse(window.localStorage.session)
		  if(session){
			  idToken = session.idToken
			  name = session.name
		  }
	  }

	  let auth ={
		  'Authorization' : idToken,
	  }
	  return auth
  },
  getLatestCampaignGroup: (state,getters) =>{
	  return state.latestCampaignGroup
  },
  gettotalCampaignAndProductCount:(state,getters) => {
	   return state.totalCampaignAndProductCount
  },
  getSelectedNotificationVendor:(state,getters) => {
	  return state.selectedVendorNotification
  },
  getisUserAdmin:(state,getters) => {
	return state.isUserAdmin
  },
  getDspAdvertiser:(state, getters) => {
	return state.dspAdvertiser
  }
},
  mutations: {
	    setTableauKey:(state,data) => {
			state.tableauTicket = data
		},
		updateKeywordsFilter:(state,data) =>{
			state.keywordsFilter = data
		},
		updateAutomationFilter:(state,data) =>{
			state.automationFilter = data
		},
		updateAccountsFilter:(state,data) =>{
			state.accountsFilter = data
		},
		updateProductsFilter:(state,data) =>{
			state.productAdvanceFilter = data
		},
		updateCampaignsFilter:(state,data) =>{
			state.campaignsFilter = data
		},
		updateKeywordList:(state,data) =>{
			state.keywordList = data
		},
		updateRecommendedKeywordList:(state,data) =>{
			state.recommendedKeywordList = data
		},
		updateTotalCampaignAndProductCount:(state, data) =>{
			state.totalCampaignAndProductCount = data;
		},
		updateDspAdvertisers:(state, data) =>{
			state.dspAdvertisers = data
		},
	setSelectedNotificationvendor:(state,data) => {
		state.selectedVendorNotification = data
	},
  	updateTotalKeywordCount:(state,data) =>{
 			state.totalKeywordCount = data;
	},
	updateRecommendedTotalKeywordCount:(state,data) =>{
		state.recommendedTotalKeywordCount = data;
	},
	updateServerReturnMessage:(state,data) =>{
		state.serverReturnMessage = data;
	},
    resetTableFooterFilter: (state, data) => {
		state.showPerPage = 25;
		state.currentPageNumber = 1;
	},
	resetKeywordTableFooterFilter: (state, data) => {
     state.keywordShowPerPage = 25;
     state.keywordCurrentPageNumber = 1;
   },
   setSelectedClientFilter: (state, data) => {
	   state.selectedClientFilter = data
   },
	setCampaignGroupFilter: (state, data) => {
		state.selectedCampaignGroupFilter = data
	},
    setSelectedVendorProduct: (state, data) => {
      state.selectedVendorProduct = data
    },
	setSelectedBrandProduct: (state, data) => {
	  state.selectedBrandProduct = data
	},
	showLoadingSpinner: (state, data) => {
	  state.showLoader = true
	},
    setSelectedVendorFilter: (state, data) => {
//	  sessionStorage.setItem("campaign:selectedVendorFilter", data);
      state.selectedVendorFilter = data
    },
    setSelectedBrandProfile: (state, data) => {
//	  sessionStorage.setItem("campaign:selectedBrandProfle", data);
      state.selectedBrandProfle = data
    },
	setisUserAdmin: (state, data) => {
		state.isUserAdmin = data
	},
    hideLoadingSpinner: (state, data) => {
      state.showLoader = false
    },
	updateSellerList: (state, data) => {
	  state.sellerList = data
	},
    updateVendorList: (state, data) => {
      state.vendorList = data
    },
	updateDspTagList: (state, data) => {
		state.dspRowCount = data.count
		state.dspTagList = data.rows
		state.showDspRows = (data.rows && data.rows.length>0)
		state.dspAdvertiser.value = (data.params && data.params.advertiser_id) ? data.params.advertiser_id : 0
		if(data.params.tag_type){
			state.dspTagType.value = (data.params && data.params.tag_type) ? data.params.tag_type : ''
			state.dspTagType.name = (data.params && data.params.tag_type) ? data.params.tag_type : ''
		}
	  },
    updateBrandProfileList: (state, data) => {
      state.brandProfileList = data
    },
	updateSeller: (state, data) => {
		state.isSeller = data
	},
	updateIsFilter: (state, data) => {
		state.isFilter = data ? data : false
	},
	updateTagFilterOptions: (state, data) => {
		state.tagFilterOptions = data
	},
	setHeaders: (state, data) => {
		state.headers = data
	},
	setGrouping: (state, data) => {
		state.grouping = data
	},
	updateLatestCampaignGroup:(state,data) => {
		state.latestCampaignGroup = data
	},
	clearSessionData:(state, data) =>{
		//clear store and session data here
		sessionStorage.clear();
		const s = initialState()
		Object.keys(s).forEach(key => {
			state[key] = s[key]
		})
	},
	clearProductList:(state) => {
		state.productList = []
	},
	setSelectedSortOrder:(state,data) => {
		state.selectedSortOrder = data
	},
	updateClientList:(state, data) => {
		state.clientList = data;
	},
	updateProfileList:(state, data) => {
		state.profileBrandList = data;
	},
	updateTotalKeywordDescCount:(state,data) =>{
		state.totalKeywordDescCount = data;
	},
	updateKeywordDescList:(state,data) => {
		state.keywordDescList = data
	},
	updateDspAdvertiser:(state,data) => {
		console.log('start',data)
		const t1 = {
			name: data.t1_tag,
			value: data.t1_tag,
		}
		const t2 = {
			name: data.t2_tag,
			value: data.t2_tag,
		}
		if(!(data.t1_tag&&data.t1_tag.name)&&t1.name) {
			data.t1_tag = t1 
		}
		if(!(data.t2_tag&&data.t2_tag.name)&&t2.name) {
			data.t2_tag = t2 
		}
		console.log('end',data)
		state.currentDspAdvertiser = data
	}
  },
  actions: {
  getAllVendor: ({commit, state, getters},data) => {
	  return new Promise((resolve, reject) => {
		  console.log('Get All Vendors Call')
			  axios({
				url: serverUrl + '/campaign/getVendor',
				method:'POST',
				headers :  getters.fetchHeader,
				data:data,
				responseType: 'json'
			  }).then((response) => {
				commit('updateVendorList', response.data)
				resolve(response.data)
			  }).catch((error) => {
				console.log(error)
			  })
	  })
	},
	getAdvertiserFromId: ({commit, state, getters},data) => {
		return new Promise((resolve, reject) => {
				axios({
				  url: serverUrl + '/campaign/dspAdvertiserOrderId',
				  method:'POST',
				  headers :  getters.fetchHeader,
				  data:data,
				  responseType: 'json'
				}).then((response) => {
					if(response.data) {
						commit('updateDspAdvertiser', response.data[0])
						resolve(response.data)
					}
				  }).catch((error) => {
					console.log(error)
				  })
		})
	},
	saveOrderTags: ({commit, state, getters},data) => {
		return new Promise((resolve, reject) => {
			data.user = JSON.parse(window.localStorage.session).name
				axios({
				  url: serverUrl + '/campaign/saveOrderTags',
				  method:'POST',
				  headers :  getters.fetchHeader,
				  data:data,
				  responseType: 'json'
				}).then((response) => {
					commit('updateServerReturnMessage', 'Success')
					resolve()
				  }).catch((error) => {
					console.log(error)
				  })
		})
	},
	getAllSellersForProduct: ({commit, state, getters},data) => {
		return new Promise((resolve, reject) => {
				axios({
				  url: serverUrl + '/product/getSellersForProduct',
				  method:'POST',
				  headers :  getters.fetchHeader,
				  data:data,
				  responseType: 'json'
				}).then((response) => {
				  commit('updateSellerList', response.data)
				  resolve(response.data)
				}).catch((error) => {
				  console.log(error)
				})
		})
	  },
	  getDspAdvertisers: ({commit, state, getters}) => {
		  return new Promise((resolve, reject) => {
				const data = {
					tag_type: 'advertiser_list'
				}
				  axios({
					url: serverUrl + '/campaign/dspTags',
					method:'POST',
					headers :  getters.fetchHeader,
					data:data,
					responseType: 'json'
				  }).then((response) => {
					commit('updateDspAdvertisers', response.data)
					resolve()
				  }).catch((error) => {
					console.log(error)
				  })
		  })
		},
	  getAllDsp: ({commit, state, getters},data) => {
		  return new Promise((resolve, reject) => {
				let pagination = {
					"pageNumber": getters.getCurrentPageNumber - 1,//0,
					"showPerPage": sessionStorage.getItem("dsp:showPerPage")
				}
				data.pagination = pagination
				commit('showLoadingSpinner', null, { root: true });

				axios({
					url: serverUrl + '/campaign/dspTags',
					method:'POST',
					headers :  getters.fetchHeader,
					data:data,
					responseType: 'json'
				}).then((response) => {
					let tag_response = {
						rows: response.data,
						params: data,
						count: response.data && response.data.length ? response.data[0].full_count : 0
					}
					commit('hideLoadingSpinner', null, { root: true })
					commit('updateDspTagList', tag_response)
					resolve()
				}).catch((error) => {
					console.log(error)
				})
		  })
		},
	getAllVendorForProduct: ({commit, state, getters},data) => {
		return new Promise((resolve, reject) => {
				axios({
				  url: serverUrl + '/product/getVendorForProduct',
				  method:'POST',
				  headers :  getters.fetchHeader,
				  data:data,
				  responseType: 'json'
				}).then((response) => {
				  commit('updateVendorList', response.data)
				  resolve(response.data)
				}).catch((error) => {
				  console.log(error)
				})
		})
	  },
	getVendorForNameList: ({commit, state, getters},data) => {
  	  return new Promise((resolve, reject) => {
  		  console.log('Get All Vendors Call')
  		  //
  			  axios({
  				url: serverUrl + '/campaign/getVendorName',
  				method:'POST',
  				headers :  getters.fetchHeader,
  				data:data,
  				responseType: 'json'
  			  }).then((response) => {
  				commit('updateVendorList', response.data)
  				resolve(response.data)
  			  }).catch((error) => {
  				console.log(error)
  			  })
  	  })
  	},
	profileBrandList: ({commit, state, getters},data) => {
  	  return new Promise((resolve, reject) => {
  		  console.log('Get All Profiles Call')
  		  //
  			  axios({
  				url: serverUrl + '/campaign/profileList',
  				method:'POST',
  				headers :  getters.fetchHeader,
  				data:data,
  				responseType: 'json'
  			  }).then((response) => {
  				commit('updateProfileList', response.data)
  				resolve(response.data)
  			  }).catch((error) => {
  				console.log(error)
  			  })
  	  })
  	},
	getAllBrandProfile: ({commit, state, getters}, data) => {
		return new Promise((resolve, reject) => {

			console.log('Get All BrandProfile Call')
			if(!data){
				data = {};
				data['vendorId'] = getters['getSelectedVendorFilter'];
			}
			axios({
			  url: serverUrl + '/campaign/getBrands',
			  method:'POST',
			  headers :  getters.fetchHeader,
			  data:data,
			  responseType: 'json'
			}).then((response) => {
				//
			  commit('updateBrandProfileList', response.data)
			  resolve(response.data)
			}).catch((error) => {
			  console.log(error)
			})
		})

   },
   getProfileForVendorInProduct: ({commit, state, getters}, data) => {
		return new Promise((resolve, reject) => {
			if(!data){
				data = {
					
				};
				// data['vendorId'] = getters['getSelectedVendorFilter'];
			}
			axios({
			url: serverUrl + '/product/getProfileForVendor',
			method:'POST',
			headers :  getters.fetchHeader,
			data:data,
			responseType: 'json'
			}).then((response) => {
				//
			commit('updateBrandProfileList', response.data)
			resolve(response.data)
			}).catch((error) => {
			console.log(error)
			})
		})

	},
   getAccountVendors:({commit, state, getters}, data) => {
	   return new Promise((resolve, reject) => {

		   axios({
			 url: serverUrl + '/account/getVendor',
			 method:'POST',
			 headers :  getters.fetchHeader,
			 data:data,
			 responseType: 'json'
		   }).then((response) => {
			   //
			 commit('updateBrandProfileList', response.data)
			 resolve(response.data)
		   }).catch((error) => {
			 console.log(error)
		   })
	   })

    },
	getAccountClient:({commit, state, getters}) => {
 	   return new Promise((resolve, reject) => {

 		   axios({
 			 url: serverUrl + '/account/getClient',
 			 method:'POST',
 			 headers :  getters.fetchHeader,
 			 responseType: 'json'
 		   }).then((response) => {
 			   commit('updateClientList', response.data)
 			 resolve(response.data)
 		   }).catch((error) => {
 			 console.log(error)
 		   })
 	   })
    },
	callAnalytics:({commit, state, getters}, data) => {
		  return new Promise((resolve, reject) => {
			  let userName = JSON.parse(window.localStorage.session).name
			  let email = JSON.parse(window.localStorage.session).username
			  if(userName){
				  let pagePath = `/${data.type}/${userName}/${email}`
				  data.this.$ga.page({
					page: pagePath,
					title: `${data.type}`,
					location: data.data
				  })
			  }
			  else if(email){
				  let pagePath = `/${type}/${email}`
				  data.this.$ga.page({
					page: pagePath,
					title: `${email}`,
					location: data.data
				  })
			  }

			  resolve('Hit')

	  })
  },
  getTableauTicket:({commit, state, getters}) => {
	 return new Promise((resolve, reject) => {
		 let url = 'http://13.233.94.83:2500/'
		 let data = {
			 username:'tbladmin'
		 }
		 axios({
		   url: url,
		   method:'POST',
		   data:data
		 }).then((response) => {
			commit("setTableauKey",response)
		   console.log(response.data)
		 }).catch((error) => {
		   console.log(error)
		 })
	 })
    },
	fetchTicketForTableau:({commit, state, getters},payload) =>{
		return new Promise((resolve,reject) => {
		let url = 'https://1gh1jui2m4.execute-api.us-east-1.amazonaws.com/prod'
		axios({
		url:url,
		method:'POST',
		data:payload
		}).then((response) => {
		resolve(response.data)
		}).catch((error) => {
		reject(error)
		})
		})
		}
  }
})
